import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const buildQueryParams = (params) => {
  return Object.entries(params)
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
};

const getDebugMessage = async (tcrid) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const queryParams = buildQueryParams({
    action: "getDebugMessage",
    companyid: user.companyid,
    token: user.token,
    tcrid,
  });

  try {
    const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryParams}`);
    return response.data;
  } catch (error) {
    console.log(error.response.data.error);
    throw error;
  }
};

const useDebugMessageQuery = (tcrid, options = {}) => {
  return useQuery({
    queryKey: ["debugMessage", tcrid],
    queryFn: () => getDebugMessage(tcrid),
    enabled: options.enabled,
    refetchInterval: 3000,
    ...options,
  });
};

export default useDebugMessageQuery;
